module.exports = __webpack_public_path__ + "static/img/login.af428171.png";